// src/components/ProgressMessage.js
import React from 'react';
import '../css/ProgressMessage.css';

const ProgressMessage = ({ message }) => {
  return (
    <div className="progress-message">
      {message}
    </div>
  );
};

export default ProgressMessage;
